import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getTheme: configurationServices.getMerchantTheme,
    modifyTheme: configurationServices.modifyMerchantTheme,
  },
  [configurationTypes.returnsPortal]: {
    getTheme: configurationServices.getPortalTheme,
    modifyTheme: configurationServices.modifyPortalTheme,
  },
}
